import { defineMessages } from 'react-intl';

const messages = defineMessages({
  signup: {
    id: 'signup',
    defaultMessage: 'Signup Block',
  },
  default: {
    id: 'default',
    defaultMessage: 'Default',
  },
  headline: {
    id: 'headline',
    defaultMessage: 'Headline',
  },
  text: {
    id: 'text',
    defaultMessage: 'Text',
  },
  title: {
    id: 'title',
    defaultMessage: 'Title',
  },
  source_input: {
    id: 'source_input',
    defaultMessage: 'source_input',
  },
});

export default messages;
